module.exports = __webpack_public_path__ + "static/samanta-tessmer-adb112f0f337537b04af147958fc7a3b.png";